<template>
  <v-app>
    <core-tool-bar />
    <core-view />
    <core-footer />
    <core-drawer />
  </v-app>
</template>

<script>
import CoreFooter from "./components/core/CoreFooter";
import CoreView from "./components/core/CoreView";
import CoreToolBar from "./components/core/CoreToolBar";
import CoreDrawer from "./components/core/CoreDrawer";


export default {
  name: "App",

  components: {
    CoreToolBar,
    CoreView,
    CoreFooter,
    CoreDrawer
  },

  data: () => ({
    //
  })
};
</script>
<style>
@import "./assets/css/index.css";
</style>
